export default "__VITE_ASSET__Cq96tCvE__"